import routes from "@/routers/routes";
import { BiHome, BiHotel } from "react-icons/bi";
import {
    PiAirplaneTiltDuotone,
    PiCalendarDuotone,
    PiCalendarPlusDuotone,
    PiFolder,
    PiFolderLockDuotone,
    PiHouseLineDuotone,
} from "react-icons/pi";
import PermissionsLists from "./PermissionsLists";
import HouseIcon from "@/components/icons/house";
import MoneyInHand from "@/components/icons/money-in-hand";

export interface SubMenu {
    icon?: any;
    name: string;
    href?: string;
    badge?: string;
    isHidden?: boolean;
    isComing?: boolean;
    role?: string | string[];
    permission?: string | string[];
    component?: JSX.Element;
}

export interface MenuItems extends SubMenu {
    isHeader?: boolean;
    dropdownItems?: SubMenu[];
}

// Note: do not add href in the label object, it is rendering as label
export const menuItems: MenuItems[] = [
    {
        name: "Overview",
        isHeader: true,
    },
    {
        name: "Dashboard",
        href: routes.dashboards.index,
        icon: <PiFolder />,
    },
    // label start
    {
        name: "Features",
        isHeader: true,
    },
    // label end
    {
        name: "Payments",
        href: routes.payments.index,
        icon: <MoneyInHand />,
    },
    {
        name: "Events",
        href: routes.events.index,
        icon: <PiCalendarDuotone />,
    },
    {
        name: "Hotels",
        href: routes.hotels.index,
        icon: <BiHotel />,
        isHidden: true,
    },
    {
        name: "Venues",
        href: routes.venues.index,
        icon: <HouseIcon />,
    },
    {
        name: "Guest Houses",
        href: routes.guestHouses.index,
        icon: <BiHome />,
        isHidden: true,
    },
    {
        name: "Flight Booking",
        href: routes.searchAndFilter.flight,
        icon: <PiAirplaneTiltDuotone />,
    },
    // label start
    {
        name: "Management",
        isHeader: true,
    },
    {
        name: "Users",
        href: routes.user.index,
        icon: "heroicons:users",
        permission: PermissionsLists.User.List,
    },
    {
        name: "Entities",
        href: routes.entity.index,
        icon: <PiHouseLineDuotone />,
        permission: PermissionsLists.Entity.List,
    },
    {
        name: "Roles & Permissions",
        href: routes.role,
        icon: <PiFolderLockDuotone />,
        permission: PermissionsLists.Role.List,
    },
    {
        name: "Configurations",
        isHeader: true,
    },
    {
        name: "Country",
        href: routes.country,
        icon: "subway:world",
        permission: PermissionsLists.Country.List,
    },
    {
        name: "City",
        href: routes.city,
        icon: "heroicons-outline:cube",
        permission: PermissionsLists.City.List,
    },
    {
        name: "Category",
        href: routes.category.index,
        icon: <PiHouseLineDuotone />,
        permission: PermissionsLists.Category.List,
    },
];